// This file is automatically generated. Do not edit manually.

import { Company } from "src/api/generated/erp/db/types/tables/company";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CompanyApi {
	export async function getSingle(args: { companyId: number }): Promise<Company> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/common/companies/getSingle",
			method: "POST",
			data: {
				companyId: args.companyId,
			},
		});
		return response as Company;
	}

	export async function getAll(): Promise<Array<Company>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/common/companies/getAll",
			method: "POST",
			data: {},
		});
		return response as Array<Company>;
	}

	export async function save(args: { company: Company }): Promise<Company> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/common/companies/save",
			method: "POST",
			data: {
				company: args.company,
			},
		});
		return response as Company;
	}

	export async function delete_(args: { companies: Array<Company> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/common/companies/delete",
			method: "POST",
			data: {
				companies: args.companies,
			},
		});
		return response as void;
	}
}
